import {IssueClosedIcon, IssueOpenedIcon, SkipIcon} from '@primer/octicons-react'

import type {IssueState, IssueStateReason} from '../hooks/__generated__/useIssueFilteringFragment.graphql'

export function getIssueIconAndFill(state: IssueState, stateReason: IssueStateReason | null | undefined) {
  let icon = IssueOpenedIcon
  let fill = 'var(--fgColor-open)'

  if (state === 'CLOSED') {
    icon = stateReason === 'COMPLETED' ? IssueClosedIcon : SkipIcon
    fill = stateReason === 'COMPLETED' ? 'var(--fgColor-done)' : 'var(--fgColor-muted)'
  }

  return {icon, fill}
}
